import { render, staticRenderFns } from "./HomeMiddle.vue?vue&type=template&id=bd8ca0b2&scoped=true&"
import script from "./HomeMiddle.vue?vue&type=script&lang=js&"
export * from "./HomeMiddle.vue?vue&type=script&lang=js&"
import style0 from "./HomeMiddle.vue?vue&type=style&index=0&id=bd8ca0b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8ca0b2",
  null
  
)

export default component.exports